"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const transactions_1 = require("@helium/transactions");
const currency_types_1 = require("./currency_types");
class CurrencyType {
    static fromTokenType(type) {
        switch (type) {
            default:
            case transactions_1.TokenType.hnt:
                return this.default;
            case transactions_1.TokenType.hst:
                return this.security;
            case transactions_1.TokenType.mobile:
                return this.mobile;
            case transactions_1.TokenType.iot:
                return this.iot;
        }
    }
    static get default() {
        return new currency_types_1.NetworkTokens();
    }
    static get networkToken() {
        return new currency_types_1.NetworkTokens();
    }
    static get mobile() {
        return new currency_types_1.MobileTokens();
    }
    static get iot() {
        return new currency_types_1.IotTokens();
    }
    static get testNetworkToken() {
        return new currency_types_1.TestNetworkTokens();
    }
    static get dataCredit() {
        return new currency_types_1.DataCredits();
    }
    static get security() {
        return new currency_types_1.SecurityTokens();
    }
    static get usd() {
        return new currency_types_1.USDollars();
    }
}
exports.default = CurrencyType;
//# sourceMappingURL=CurrencyType.js.map